import webClient from "../config/api.config";
import { FeaturePayloadVM } from "../types/feature.definition";

export function getAllFeatures(lang = "fr") {
  return webClient.request({
    method: "get",
    url: "/features",
    params: { lang },
  });
}

export function getFeatureById(id: number, lang: string) {
  return webClient.request({
    method: "get",
    url: `/features/${id}`,
    params: { lang },
  });
}

export function createFeature(data: FeaturePayloadVM) {
  return webClient.request({ method: "post", url: "/features", data });
}

export function updateFeature(id: number, data: FeaturePayloadVM) {
  return webClient.request({ method: "put", url: `/features/${id}`, data });
}

export function toggleFeature(id: number) {
  return webClient.request({ method: "patch", url: `/features/${id}/toggle` });
}

export function deleteFeature(id: number) {
  return webClient.request({ method: "delete", url: `/features/${id}` });
}
